var _g, _g2, _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTabDdxInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_604_24431)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 32,
    height: 32,
    rx: 10,
    fill: "#7742FE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_604_24431)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 32,
    height: 32,
    rx: 10,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 11L23 10L25 12.5L27 15.5L26 28H14V11Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.74 14.3302L23.3 9.33018C23.2065 9.22659 23.0924 9.14371 22.9649 9.08688C22.8375 9.03004 22.6995 9.00051 22.56 9.00018H14.56C14.2277 8.99622 13.898 9.05774 13.5895 9.18124C13.281 9.30473 12.9999 9.48778 12.7622 9.71993C12.5245 9.95209 12.3348 10.2288 12.204 10.5342C12.0732 10.8397 12.0039 11.1679 12 11.5002V26.5002C12.0039 26.8324 12.0732 27.1607 12.204 27.4661C12.3348 27.7716 12.5245 28.0483 12.7622 28.2804C12.9999 28.5126 13.281 28.6956 13.5895 28.8191C13.898 28.9426 14.2277 29.0041 14.56 29.0002H25.44C25.7723 29.0041 26.102 28.9426 26.4105 28.8191C26.719 28.6956 27.0001 28.5126 27.2378 28.2804C27.4755 28.0483 27.6652 27.7716 27.796 27.4661C27.9268 27.1607 27.9961 26.8324 28 26.5002V15.0002C27.9994 14.7523 27.9067 14.5136 27.74 14.3302ZM17 19.0002H20C20.2652 19.0002 20.5196 19.1055 20.7071 19.2931C20.8946 19.4806 21 19.735 21 20.0002C21 20.2654 20.8946 20.5198 20.7071 20.7073C20.5196 20.8948 20.2652 21.0002 20 21.0002H17C16.7348 21.0002 16.4804 20.8948 16.2929 20.7073C16.1054 20.5198 16 20.2654 16 20.0002C16 19.735 16.1054 19.4806 16.2929 19.2931C16.4804 19.1055 16.7348 19.0002 17 19.0002ZM23 25.0002H17C16.7348 25.0002 16.4804 24.8948 16.2929 24.7073C16.1054 24.5198 16 24.2654 16 24.0002C16 23.735 16.1054 23.4806 16.2929 23.2931C16.4804 23.1055 16.7348 23.0002 17 23.0002H23C23.2652 23.0002 23.5196 23.1055 23.7071 23.2931C23.8946 23.4806 24 23.735 24 24.0002C24 24.2654 23.8946 24.5198 23.7071 24.7073C23.5196 24.8948 23.2652 25.0002 23 25.0002ZM22.71 15.0002C22.5038 14.9799 22.3139 14.8794 22.1811 14.7204C22.0483 14.5614 21.9833 14.3567 22 14.1502V11.0002L25.74 15.0002H22.71Z",
    fill: "#7742FE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 11.6662C30 11.6662 30 11.6662 30 11.6662C30 10.1937 28.7912 9 27.3 9C26.6085 9 25.9777 9.25671 25.5 9.67889C25.0223 9.25671 24.3915 9 23.7 9C22.2088 9 21 10.1937 21 11.6662C21 11.6662 21 11.6662 21 11.6662C21 14.9327 24.0022 16.468 25.1022 16.9209C25.3585 17.0264 25.6415 17.0264 25.8978 16.9209C26.9978 16.468 30 14.9327 30 11.6662Z",
    fill: "#C6AFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 12.5556H27.8626L27.2946 11.2694C27.2225 11.106 27.0569 11 26.8738 11C26.6906 11 26.525 11.106 26.4529 11.2694L25.5 13.4273L25.234 12.8249C25.1619 12.6615 24.9963 12.5556 24.8131 12.5556H21C21.0576 12.8707 21.1448 13.1668 21.2554 13.4444H24.5112L25.0791 14.7306C25.1513 14.894 25.3168 15 25.5 15C25.6832 15 25.8487 14.894 25.9209 14.7306L26.8738 12.5727L27.1397 13.1751C27.2119 13.3385 27.3774 13.4444 27.5606 13.4444H29.7446C29.8552 13.1668 29.9424 12.8707 30 12.5556Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_604_24431",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.289653 0 0 0 0 0.179688 0 0 0 0 0.375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_604_24431"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_604_24431",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_604_24431",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.289653 0 0 0 0 0.179688 0 0 0 0 0.375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_604_24431"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_604_24431",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabDdxInactive);
export default __webpack_public_path__ + "static/media/tab-ddx-inactive.1121a895d61e7042d97dc11e52d9ec0b.svg";
export { ForwardRef as ReactComponent };